import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  declare readonly urlValue: string

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.#toast("Link copied!")
    } catch {
      this.#toast("Couldn't copy the link. Please copy it from the address bar.", "error")
    }
  }

  #toast(message: string, variant: "success" | "error" = "success") {
    this.dispatch("show", { prefix: "toast", target: window, detail: { message, variant } })
  }
}
